import React from 'react';
import {useTranslation} from "react-i18next";

const banks = (props) => {
    const {i18n} = useTranslation();
    let img = "";

    switch (props.type) {
        case 'VISA':
            img = <div className="cardicon cardicon--visa-small"></div>;
            break;
        case 'MC':
            img = <div className="cardicon cardicon--mc-small"></div>;
            break;
        case 'AMEX':
            img = <div className="cardicon cardicon--amex-small"></div>;
            break;
        case 'DINERS':
            img = <div className="cardicon cardicon--diners-small"></div>;
            break;
        case 'DISCOVER':
            img = <div className="cardicon cardicon--discover-small"></div>;
            break;
        case 'JCB':
            img = <div className="cardicon cardicon--jcb-small"></div>;
            break;
    }
    img = <span></span>
    return img;
};

export default banks
